import type { FC, ReactNode } from 'react'

import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area'

import type { ChatAttachment } from './chat-input-attachment.interface'
import { ChatInputImagePreview } from './chat-input-image-preview.atom'

interface ChatInputImageListProps {
  imageList: ChatAttachment[]
  onRemove: (id: string) => void
}

/**
 * Scrollable list of image attachment previews.
 */
export const ChatInputImageList: FC<ChatInputImageListProps> = ({
  imageList,
  onRemove,
}): ReactNode => (
  <div className="chat-input-attachment-images">
    <ScrollArea className="w-full">
      <div className="flex gap-2 p-0.5 pb-1.5">
        {imageList.map((image) => (
          <ChatInputImagePreview key={image.id} attachment={image} onRemove={onRemove} />
        ))}
      </div>
      <ScrollBar orientation="horizontal" />
    </ScrollArea>
  </div>
)

ChatInputImageList.displayName = 'ChatInputImageList'
